import {useQuery} from 'react-query'

import {api, queryClient, useMutationQuery, LONG_STALE_QUERY_TIME} from 'base'

export const useGetChat = (projectUuid: string) =>
  useQuery<any>(
    ['chat', projectUuid],
    async () => {
      const {data} = await api.get(`/chat/project/${projectUuid}`)
      const sortedMessagesData = {
        ...data.data,
        messages: data.data.messages.slice(),
      }
      sortedMessagesData.messages.sort((a: any, b: any) => a.id - b.id)
      return sortedMessagesData
    },
    {refetchInterval: LONG_STALE_QUERY_TIME}
  )

export const useSendMessage = (projectUuid: string, chatUuid: string) =>
  useMutationQuery<any, any, any>(
    ['sendMessage', chatUuid],
    async ({tempId, ...values}) => {
      const {data} = await api.post(`/chat/${chatUuid}`, values)
      return data.data
    },
    {
      onSuccess(data, values) {
        const requestKey = ['chat', projectUuid]
        queryClient.setQueriesData(requestKey, (oldData: any) => {
          const newData = {
            ...oldData,
            messages: oldData.messages.slice(),
          }
          const tempMessageIndex = newData.messages.findIndex(
            (message: any) => message.id === values.tempId
          )
          newData.messages[tempMessageIndex] = data
          return newData
        })
        queryClient.invalidateQueries(requestKey)
        queryClient.invalidateQueries('projectChatFiles')
      },
      onError(_, values) {
        const queryKey = ['chat', projectUuid]
        queryClient.setQueriesData(queryKey, (oldData: any) => {
          const newData = {
            ...oldData,
            messages: oldData.messages.filter(
              (message: any) => message.id !== values.tempId
            ),
          }
          return newData
        })
      },
    }
  )
